import { initialAdvertisersState } from 'redux/initialState';
import { status } from 'constants/general';

import advertisersActionTypes from './action-types';

const advertisersReducer = (state = initialAdvertisersState, { type, payload }) => {
  switch (type) {
    case advertisersActionTypes.FETCH_ADVERTISERS_LIST:
      return {
        ...state,
        advertisersList: {
          status: status.FETCHING,
        },
      };

    case advertisersActionTypes.FETCH_ADVERTISERS_LIST_SUCCESS:
      return {
        ...state,
        advertisersList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case advertisersActionTypes.FETCH_ADVERTISERS_LIST_FAIL:
      return {
        ...state,
        advertisersList: {
          status: status.FAIL,
        },
      };

    case advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION:
      return {
        ...state,
        addOrEditAdvertiser: {
          status: status.FETCHING,
        },
      };

    case advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_SUCCESS:
      return {
        ...state,
        addOrEditAdvertiser: {
          status: status.SUCCESS,
        },
      };

    case advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION_FAIL:
      return {
        ...state,
        addOrEditAdvertiser: {
          status: status.FAIL,
        },
      };

    case advertisersActionTypes.SET_ADVERTISER_DETAILS:
      return {
        ...state,
        advertiserDetails: {
          ...payload,
        },
      };

    default:
      return state;
  }
};

export default advertisersReducer;
